<!-- 轮播图组件 -->
<template>
  <div class="rotation">


    <div class="boxS">
      <div class="search">
        <!-- <div class="shu"></div> -->
        <el-select v-model="select" slot="prepend">
          <el-option label="影像馆" value="yxg" v-if="type !== 'video' & type !== 'photo'"></el-option>
          <el-option label="图片" value="img"></el-option>
          <el-option label="视频" value="video"></el-option>
        </el-select>
        <el-input placeholder="开启云端旅行..." v-model="term" @keyup.enter.native="onSearch">
        </el-input>
        <el-button style="" slot="append" icon="el-icon-search" class="searchbtn" @click="onSearch"
          @keyup.enter="onSearch">
        </el-button>

      </div>
    </div>

    <el-carousel v-if="type !== 'video'" class="demonstration" trigger="click">
      <!-- <el-carousel-item v-for="tableData in 4" :key="tableData"> -->

      <el-carousel-item style="height:100%" v-for="(item, i) in tableData" :key="i">
        <transition name="el-fade-in">
          <img class="imageTo" :src="item.imagLink + '?x-oss-process=image/resize,h_1000'" @click="go(item)" />
        </transition>
        <h3 class="small">{{ item.imagLink }}</h3>
      </el-carousel-item>

    </el-carousel>

    <div class="videoBox" v-else>
      <video playsinline="false" webkit-playsinline="false" src="@/imgs/video.mp4" autoplay muted loop></video>
    </div>
  </div>
</template>
<script>
import img_url from "../assets/logo.png";
import { setLocalStorage } from "../utils/auth";
import { getLocalStorage } from "../utils/auth";
import { setToken } from "../utils/auth";

export default {
  props: {
    type: {
      type: String,
    }
  },
  name: "rotation",
  data() {
    return {
      queryObj: {
        current: 1,
        size: 20,
        advertisementType: 1,
        commendType: 3
      },
      // input3: "",
      select: "img",
      tableData: [],
      // urlList: ['http://localhost:3000/attchments/work/2020619/1592560044555-自在如风的少年.jpg', 'http://localhost:3000/attchments/work/2020619/1592560325880-磊-重庆场.jpg'],
      // 搜索参数
      term: '',


    };
  },
  created() {
    console.log(this.type);
    if (this.type == 'yxg') {
      this.select = 'yxg'
    } else if (this.type == 'video') {
      this.select = 'video'
    } else {
      this.select = 'img'
    }
    this.handleRotation();
  },
  methods: {
    // 轮播图请求
    async handleRotation() {
      if (this.type == 'home') {
        this.queryObj = {
          commendType: 1
        }
      } else if (this.type == 'photo') {
        this.queryObj = {
          commendType: 2,
        }
      } else if (this.type == 'video') {
        this.queryObj = {
          commendType: 3,
        }
      } else {
        this.queryObj = {
          commendType: 5,
        }
      }
      const res = await this.$axios.get(`/homeReception/findChart`, { params: this.queryObj })
      this.tableData = res.data
      // console.log(this.tableData);

    },
    // 搜索
    async onSearch() {
      if (this.term !== "") {
        const { href } = this.$router.resolve({
          path: '/photoSearchResule',
          query: {
            term: this.term,
            type: this.select
          }
        })
        this.term = ""
        window.open(href, '_blank')
      }

    },
    // 点击轮播图
    go(item) {
      if (this.type == 'home') {
        if (item.linkType == '1') {
          let { href } = this.$router.resolve(`/activeDetail?id=${item.idOrLink}`)
          window.open(href, '_blank')
        } else if (item.linkType == '2') {
          let { href } = this.$router.resolve(`/photoDetail?id=${item.idOrLink}`)
          window.open(href, '_blank')
        } else if (item.linkType == '3') {
          let { href } = this.$router.resolve(`/destinationHome?id=${item.idOrLink}`)
          window.open(href, '_blank')
        } else if (item.linkType == '4') {
          let { href } = this.$router.resolve(`/myWork?userId=${item.idOrLink}`)
          window.open(href, '_blank')
        } else {
          window.open(item.idOrLink, '_blank')
        }
      } else if (this.type == 'video') {
        let { href } = this.$router.resolve(`/videoDetail?id=${item.idOrLink}`)
        window.open(href, '_blank')
      } else if (this.type == 'yxg') {
        let { href } = this.$router.resolve(`/destinationHome?id=${item.idOrLink}`)
        window.open(href, '_blank')
      } else {
        let { href } = this.$router.resolve(`/photoDetail?id=${item.idOrLink}`)
        window.open(href, '_blank')
      }

    }
  }
};
</script>

<style scoped lang="scss">
/* .rotation{
     width: 100%;
} @import url("//unpkg.com/element-ui@2.15.7/lib/theme-chalk/index.css");*/

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 500px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.rotation {
  position: relative;
  width: 100%;
  height: 500px;
  /* object-fit: cover; */
  display: block;
  display: flex;
}

.boxS {
  position: absolute;
  top: 50%;
  right: 50px;
  transform: translate(-50%, -50%);
  width: 889px;
  height: 60px;
  z-index: 777;

  .search {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;

    .shu {
      height: 20px;
      width: 1px;
      background-color: #333;
      position: absolute;
      left: 115px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 99999;
    }

    /deep/ .el-input {
      height: 100%;
      border: none;
      border-radius: none !important;

    }

    /deep/ .el-input .el-input__inner {
      border-radius: 0px;
      /*输入框圆角值*/
      height: 100%;
      background: rgba(245, 245, 245, 0.84);

      &:focus {
        border: 0;
      }

      &:active {
        border: 0;
      }
    }

    /deep/ .el-select {
      width: 150px;
      text-align: center;
    }

    /deep/ .el-select .el-input__inner {
      background: rgba(245, 245, 245, 0.84);
      text-align: center;
      border-radius: 5px 0 0 5px;
    }


    .searchbtn {
      height: 100%;
      width: 100px;
      border-radius: 0;
      background: rgba(245, 245, 245, 0.84);
      margin: 0;
      border-radius: 0 5px 5px 0;

      /deep/ .el-icon-search {
        font-size: 23px;
        color: #DC3B3B;
        font-weight: 700;

      }

      &:hover {
        border: 0;
      }

      &:focus {
        border: 0;
      }

      &:active {
        border: 0;
      }
    }

  }
}

.videoBox {
  width: 100%;
  height: 100%;

  // background-color: red;
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

/deep/ .el-select .el-input .el-select__caret {
  color: #333;
}

/deep/ .el-input__inner::placeholder {
  color: #727272;
}


.rotation .demonstration {
  object-fit: cover;
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 500px;
  left: 0px;
  top: 0px;
}

/deep/ .el-carousel__container {
  width: 100%;
  height: 100%;
}

.el-select-dropdown__item {
  font-size: 14px;
  padding: 0 20px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #998f8d;
  height: 42px;
  line-height: 42px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}




.imageTo {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.el-select-dropdown__item:hover {
  background-color: #dc3b3b;
  color: #fff !important;
}

.el-select-dropdown__list {
  height: 168px;
  list-style: none;
  padding: 6px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.el-input-group>.el-input__inner {
  vertical-align: middle;
  height: 60px;
  display: table-cell;
}

.el-select-dropdown__item.selected {
  color: #db3a3b;
}

.el-input__inner {
  text-align: center;
}

.el-input-group>.el-input__inner {
  text-align: left;
}

/deep/ .el-input-group--append .el-input__inner {
  background: rgba(245, 245, 245, 0.84);
  height: 60px;
}

.el-input-group__prepend div.el-select /deep/ .el-input__inner {
  text-align: center !important;
}


// 轮播图指示器

.demonstration {
  /deep/ .el-carousel__button {
    display: block;
    width: 10px;
    height: 10px;
    background: #D9D9D9;
    border-radius: 50%;
    opacity: 0.7;
    border: 0 !important;
    border-radius: 50%;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: 0.3s;
  }

  /deep/ .el-carousel__indicator.is-active button {
    width: 26px;
    height: 10px;
    background: #DC3B3B;
    opacity: 1;
    border-radius: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rotation.vue